import React from 'react';
import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import { DateRangePicker } from 'react-dates';
import { dateInternationalization, isRTL } from '../../helpers/formatLocale';
import messages from '../../locale/jsonMessages';
import { dateFormat } from '../../config';

import s from 'react-dates/lib/css/_datepicker.css';
import t from '../../styles/reactDatesCalendar.css';


class DateRange extends React.Component {
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            focusedInput: null,
            startDate: null,
            endDate: null,
            isCurrentStatus: 2,
            from: undefined,
            to: undefined,
            dateRange: [],
        };

        this.onDatesChange = this.onDatesChange.bind(this);
    }

    componentDidMount() {
        const { defaultStartDate, defaultEndDate, isCurrentStatus } = this.props;

        this.setState({
            isCurrentStatus: isCurrentStatus,
            startDate: defaultStartDate ? moment(defaultStartDate) : null,
            endDate: defaultEndDate ? moment(defaultEndDate) : null,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { defaultStartDate, defaultEndDate, isCurrentStatus } = nextProps;
        this.setState({
            isCurrentStatus: isCurrentStatus,
            startDate: defaultStartDate ? moment(defaultStartDate) : null,
            endDate: defaultEndDate ? moment(defaultEndDate) : null,
        });
    }


    async onDatesChange({ startDate, endDate }) {
        const { formName, change, startDateName, endDateName, resetCalendar } = this.props;
        const { isCurrentStatus } = this.state;
        const { onChange } = this.props;
        this.setState({ startDate, endDate });

        change(formName, 'startDate', startDate);
        change(formName, 'endDate', endDate);

        await resetCalendar();
    }


    render() {
        const { focusedInput, startDate, endDate, isCurrentStatus } = this.state;
        const { intl: { locale } } = this.props;
        const { formatMessage } = this.props.intl;
        dateInternationalization(locale);
        return (
            <div>
                <DateRangePicker
                    displayFormat={dateFormat?.shortDateFormat}
                    {...this.props}
                    onDatesChange={this.onDatesChange}
                    focusedInput={focusedInput}
                    startDate={startDate}
                    endDate={endDate}
                    numberOfMonths={1}
                    startDatePlaceholderText={formatMessage(messages.startDate)}
                    endDatePlaceholderText={formatMessage(messages.endDate)}
                    minimumNights={0}
                    hideKeyboardShortcutsPanel
                    minimumNights={0}
                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                    readOnly
                    className={cx('specialPriceCalendar')}
                    anchorDirection={isRTL(locale) ? 'right' : 'left'}
                    isRTL={isRTL(locale)}
                />
            </div>
        );
    }
}

const selector = formValueSelector('ListPlaceStep3'); // <-- same as form name

const mapState = (state) => ({
    defaultStartDate: selector(state, 'startDate'),
    defaultEndDate: selector(state, 'endDate'),
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(s, t)(connect(mapState, mapDispatch)(DateRange)));
